var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCrowdstrike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "All_Logos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380 160",
    style: {
      enableBackground: "new 0 0 380 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FC0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M59.9,88.7V88l-5.4-4.7h-0.6c-1.6,1.8-4,2.9-6.4,2.9c-4,0-7.3-3.3-7.3-7.3c0-4,3.3-7.3,7.3-7.3 c2.4,0,4.8,1.1,6.4,2.9h0.6l5.4-4.7v-0.6c-3.1-3.7-7.6-5.8-12.4-5.7c-9.3,0-16.4,6.6-16.4,15.5c0,0.3,0.1,0.7,0.1,1 c3.8,2.6,7.2,4.7,10.1,6.6c3.6,2.2,7,4.7,10.3,7.4C54.9,93,57.8,91.2,59.9,88.7 M34.5,88.5c2.3,2.8,5.4,4.7,8.9,5.4 c-2.5-1.4-4.8-2.7-7-4.2C35.7,89.3,35.2,88.9,34.5,88.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M91.4,92.4l-1.4-5.9l-0.5-0.3c-0.3,0.2-0.8,0.3-1.2,0.3c-1,0-1.7-1.1-2.2-2 c-0.5-1-1.3-1.8-2.3-2.4c3.4-1.3,5.6-4.5,5.5-8.1c0-6.1-4.2-10-11.9-10H64v29.9h9V83.4h0.8c2,0,4.5,4.3,5.7,6.2 c2.4,3.9,4.4,4.8,7.9,4.8c1.4,0,2.7-0.4,3.8-1.3L91.4,92.4z M80.3,74.4c0.1,1.6-1.2,2.9-2.8,3c-0.1,0-0.2,0-0.4,0H73v-6h4.2 c1.7-0.1,3.1,1.2,3.1,2.9C80.3,74.3,80.3,74.4,80.3,74.4L80.3,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st0",
    d: "M126.1,79c0-8.9-7.1-15.5-16.5-15.5S93.2,70.1,93.2,79s7.1,15.5,16.5,15.5S126.1,87.8,126.1,79  M116.9,79c0,4-3.3,7.3-7.3,7.3c-4,0-7.3-3.3-7.3-7.3c0-4,3.3-7.3,7.3-7.3c0,0,0,0,0,0c3.9-0.1,7.2,3,7.3,7 C116.9,78.8,116.9,78.9,116.9,79"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "st0",
    points: "171,64 162.5,64 157.1,80.6 151.5,64 146.1,64 140.5,80.5 135.2,64 126.6,64  126.2,64.7 137.2,93.9 142.6,93.9 148.8,77.6 155,93.9 160.5,93.9 171.4,64.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st0",
    d: "M204.3,78.9c0-8.9-5.9-14.9-15.6-14.9H175v29.9h13.7C198.4,93.9,204.3,87.9,204.3,78.9  M195.1,78.9c0,4.9-2.9,7.6-6.8,7.6h-4.4V71.4h4.4C192.3,71.4,195.1,74.1,195.1,78.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "st0",
    points: "251.8,71.4 260.8,71.4 260.8,64 233.9,64 233.9,71.4 242.9,71.4 242.9,93.9  251.8,93.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st0",
    d: "M289.5,74c0-6.1-4.2-10-11.9-10h-13.5v29.9h9V83.4h2.1l5.6,10.5h8.9l0.4-0.7l-6-11.1 C287.4,80.8,289.6,77.6,289.5,74 M280.4,74.5c0.1,1.6-1.2,2.9-2.8,3c-0.1,0-0.2,0-0.4,0h-4.2v-6.1h4.2c1.7-0.1,3.1,1.2,3.1,2.9 C280.4,74.3,280.4,74.4,280.4,74.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    className: "st0",
    points: "295,93.9 303.9,93.9 303.9,64 295,64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    className: "st0",
    points: "326.7,77.4 336.8,64.7 336.4,64 326.9,64 318.6,74.6 318.6,64 309.6,64 309.6,93.9  318.6,93.9 318.6,84.7 320.2,82.8 327.8,93.9 337.2,93.9 337.6,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    className: "st0",
    points: "340.1,64 340.1,93.9 362.6,93.9 362.6,86.5 349,86.5 349,82.4 359.3,82.4 359.3,75.5  349,75.5 349,71.4 362.5,71.4 362.5,64  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st0",
    d: "M219.5,94.2c6.6,0,12.3-3.2,12.3-9.4c0-6.8-5.8-8.5-10.8-10c-2-0.6-4-1.3-4-2.8 c0-1.1,1.1-1.7,2.9-1.7c2.5,0.1,4.9,1.2,6.7,3h0.6l4.2-5.1v-0.6c-2.2-2.5-6.8-4.5-11.7-4.5c-7,0-11.8,3.8-11.8,9.2 c0,5.9,5.4,8.4,9.9,9.7c2.9,0.8,4.9,1,4.9,2.6c0,1.2-1.4,1.8-3.6,1.8c-2.9-0.2-5.6-1.4-7.8-3.4h-0.6l-4.2,5.2v0.7 C209.1,92.1,213.9,94.2,219.5,94.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "st0",
    d: "M64.7,121.7c-2.2-5-6.5-11.4-23.7-20.5c-7.9-4.4-21.4-11.2-33.5-24 c1.1,4.6,6.7,14.8,30.9,27.5C45.2,108.4,56.5,111.8,64.7,121.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "st0",
    d: "M63.7,113.1c-2.1-5.9-5.8-13.4-23.5-24.6C31.6,82.9,19,75.8,2.3,57.8 c1.2,4.9,6.4,17.5,32.9,34C44,97.6,55.2,101.2,63.7,113.1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCrowdstrike);
export default __webpack_public_path__ + "static/media/logo_crowdstrike.814e95f0b6ae46e95866cb871d01cabd.svg";
export { ForwardRef as ReactComponent };